import Vue from 'vue';

export const registrationPlate = (value) => {
  if (!value) return '';
  value = value.toString();

  return value.replace(/^(.*)(\d{4})$/, '$1-$2');
}

Vue.filter('plate', registrationPlate);
Vue.filter('registrationPlate', registrationPlate);
